export const getLocalToken = () => localStorage.getItem("cancontrol_token");
export const setLocalToken = token =>
  localStorage.setItem("cancontrol_token", token);
export const deleteLocalToken = () =>
  localStorage.removeItem("cancontrol_token");
